<template>
  <div class="moduleFive">
    <div :style="imgHeight" style="margin: auto">
      <img :src="this.img" />
    </div>
    <div v-html="this.description" style="padding: 20px 80px"></div>
    <div style="display:flex;flex-wrap: wrap">
      <div v-for="(item, index) in modChild" :key="index" style="width: 50%">
        <div style="display: flex;justify-content: center;padding: 10px 0">
          <div
            v-html="item.name + ':'"
            style="margin: auto 0;padding-right: 10px"
          ></div>
          <el-input
            style="width: auto"
            v-if="item.type === 1"
            placeholder="请输入内容"
            v-model="item.inputData"
            clearable
          >
          </el-input>
          <el-select
            v-if="item.type === 2"
            v-model="item.inputData"
            placeholder="请选择"
          >
            <el-option
              v-for="(temp, index) in item.selectOptions"
              :key="index"
              :label="temp.name"
              :value="temp.code"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-upload
      class="upload-demo"
      action="/api/file/upload"
      :on-success="handleSuccess"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      multiple
      :limit="3"
      :on-exceed="handleExceed"
      :file-list="fileList"
      name="uploadFile"
    >
      <el-button v-if="this.resumeStatus" size="small" type="primary">
        点击上传简历
      </el-button>
    </el-upload>
    <div style="text-align: center;padding-top: 10px" v-if="modChild">
      <el-button type="primary" round @click="submit">提交申请</el-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      img: "",
      imgHeight: {
        height: "",
        width: "70%"
      },
      description: "", // 加入我们文字
      modChild: [], // 加入我们的填写信息
      fileList: [],
      resume: "", // 简历
      resumeStatus: "", // 是否显示简历
      companyId: "" // 公司ID
    };
  },
  mounted() {
    this.getmod5();
    this.innerHeight();
  },
  methods: {
    innerHeight() {
      this.imgHeight.height = window.innerHeight / 1.5 + "px";
    },
    getmod5() {
      let domain = window.location.href.split("/");
      axios.get("/api/home/joinus?companyUrl=" + domain[2]).then(res => {
        this.img = res.data.data.img;
        this.description = res.data.data.description;
        this.resumeStatus = res.data.data.resume;
        this.companyId = res.data.data.companyId;
        // console.log(res.data.data, "res");
        const vm = this;
        let resList = res.data.data.jobData;
        // console.log(resList, 123);
        resList.forEach(el => {
          let list = JSON.parse(el.jobData);
          // console.log(list, "list");
          list.inputData = "";
          vm.modChild.push(list);
          if (list.type === 2 && list.content) {
            // 选择框数据处理
            list.selectOptions = [];
            let selectData = list.content;
            selectData.forEach(element => {
              let obj = {
                name: element,
                code: element
              };
              list.selectOptions.push(obj);
            });
          }
        });
      });
    },
    submit() {
      let joinDataModuleDto = [];
      joinDataModuleDto.joinDataModuleDto = [];
      let flag = 1;
      this.modChild.forEach(el => {
        if (el.inputData === "") {
          flag = 0;
        }
        joinDataModuleDto.joinDataModuleDto.push({
          content: el.inputData,
          name: el.name,
          type: el.type
        });
      });
      // console.log(joinDataModuleDto, "0.0000");
      if (flag) {
        axios
          .post("/api/home/joinadd", {
            ...joinDataModuleDto,
            resume: this.resume,
            companyId: this.companyId
          })
          .then(res => {
            if (res.data.data) {
              this.$message({
                type: "success",
                message: res.data.data
              });
            } else {
              this.$message.error(res.data.data);
            }
          });
      } else {
        this.$message.error("请填写完全部信息");
      }
    },
    handleSuccess(response) {
      this.resume = response.data.fileurl;
      this.$message({
        type: "success",
        message: "上传成功"
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style lang="sass">
.moduleFive
  white-space: normal
  word-break: break-all;overflow:hidden
  padding-bottom: 45px
  img
    width: 100%
    height: 100%
  .upload-demo
    padding-top: 20px
    width: 48.5%
    margin: auto
</style>
